import { Dialog } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { IoClose } from 'react-icons/io5'
import { TbSquareNumber1Filled, TbSquareNumber2Filled, TbSquareNumber3Filled } from 'react-icons/tb'

const AddYourGuestModal = ({ displayModal, setDisplayModal }) => {
    const { t } = useTranslation('AddGuestModal');
    const handleclose = () => {
        localStorage.setItem("addGuestModal", true);
        setDisplayModal(false);

    }
    useEffect(() => {
        const returnmodal = localStorage.getItem("addGuestModal");
        setDisplayModal(!returnmodal);
    }, [])
    return (
        <>
            {
                displayModal && (
                    <Dialog
                        open={displayModal}
                        onClose={handleclose}
                        PaperProps={{
                            sx: {
                                borderRadius: "20px",
                                width: "630px",

                            },
                        }}

                    >
                        <div className="bg-white p-5  flex flex-col gap-3 rounded-[20px]">
                            <div className="div">
                                <div className="flex  items-start justify-between w-full ">
                                    <span className='text-[18px] font-[600] text-[#131415] '>{t("welcomeMessage")}</span>
                                    <span onClick={handleclose} ><IoClose size={25} className='cursor-pointer' /></span>
                                </div>

                            </div>
                            <div className="bg-[#F6F6F6] p-3 rounded-[9px] grid gap-4 ">
                                <p className='font-[600] text-[#131415] text-[18px] ' >{t("gettingStarted")}</p>
                                <div className='flex gap-2 text-[14px] items-start'>
                                    <span><TbSquareNumber1Filled fill='#3686FF' size={25} /></span>
                                    <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t("step1.title")}: </span>{t("step1.description")}</p>
                                </div>
                                <div className='flex gap-2 text-[14px] items-start'>
                                    <span><TbSquareNumber2Filled fill='#3686FF' size={25} /></span>
                                    <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t("step2.title")}:</span>  {t("step2.title")}</p>
                                </div>
                                <div className='flex gap-2 text-[14px] items-start'>
                                    <span><TbSquareNumber3Filled fill='#3686FF' size={25} /></span>
                                    <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t("step3.title")}: </span>  {t("step3.title")}</p>
                                </div>
                                <p className='text-[#535861] text-[14px] pl-1'>{t("additionalInfo")}</p>

                            </div>
                        </div>
                    </Dialog >
                )
            }
        </>
    )
}

export default AddYourGuestModal